import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RcaHeader from 'rca-header-component';
import styles from './Header.scss';
import headerConfig from './config';
import * as creators from '../actions/creators';
import { changeAppRoute } from '../../../shared/components/Link';
import { withUserAgent } from '../../../shared/userAgentContext';
import { parseConfig } from '../../../shared/config';


export const Header = ({
  pathname = '/',
  isSignedIn,
  theme,
  navigationLinks,
  onLogOut,
  isIE,
}) => {
  const onRouteChange = (event, href) => {
    event.preventDefault(event);
    changeAppRoute(href);
  };

  const { LOCKE_CLIENT_ID, LOCKE_AUTH_REDIRECT_URL } = parseConfig();

  return (
    <div className={styles.wrapper}>
      <RcaHeader
        pathname={pathname}
        isSignedIn={isSignedIn}
        theme={theme || headerConfig.theme}
        navigationLinks={navigationLinks || headerConfig.navigationLinks}
        lockeClientId={LOCKE_CLIENT_ID}
        lockeRedirectUri={LOCKE_AUTH_REDIRECT_URL}
        onRouteChange={onRouteChange}
        onLogOut={onLogOut}
        showBrowserWarning={isIE}
      />
    </div>
  );
};

export const headerPropTypes = {
  pathname: PropTypes.string,
  isSignedIn: PropTypes.bool,
  theme: PropTypes.string,
  navigationLinks: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      internal: PropTypes.boolean,
    }),
  ),
  onLogOut: PropTypes.func,
  isIE: PropTypes.bool,
};

Header.propTypes = headerPropTypes;

export default withUserAgent(['isIE'])(connect(
  state => ({ isSignedIn: state.myRCA.isSignedIn }),
  { onLogOut: creators.resetLoginState },
)(Header));
